export default __webpack_public_path__ + "static/media/sass.8351205a.svg";